/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/context_menu.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { contextMenuModule } from "../../../grids/grid_core/context_menu/m_context_menu";
import treeListCore from "../m_core";
treeListCore.registerModule("contextMenu", contextMenuModule);